import { AHIcon, AHIconType, AHText, Box } from "arkh";
import React, { PropsWithChildren } from "react";

export function Header(
  props: PropsWithChildren<{
    icon: AHIconType;
    subtitle?: React.ReactNode;
  }>
) {
  return (
    <Box
      spaceVertical="small"
      spaceHorizontal="small"
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <AHIcon type={props.icon} size="medium" />
      <Box spaceLeft="small" style={{ flex: 1 }}>
        <AHText type="subtitle" style={{ flex: 1 }}>
          {props.children}
        </AHText>
        {props.subtitle ? (
          <AHText type="detail">{props.subtitle}</AHText>
        ) : null}
      </Box>
    </Box>
  );
}
